import { Middleware, AnyAction } from 'redux';
import { errors as amwellErrors } from 'lib/amwell/client/constants';
import AwsdkError from 'lib/amwell/client/errors/AwsdkError';
import { isActionOfType } from 'store/utils';
import * as authActions from 'store/authentication/actions';
import * as accActions from 'store/account/actions';
import * as awActions from './actions';
import { ActivityStatus } from './types';

const LOGOUT_TYPES = [
  authActions.AUTHENTICATE_LOGOUT,
  authActions.AUTHENTICATE_RESET_ACCESS_TOKEN,
  accActions.switchAccountSuccess.type
];

const EXPIRED_TYPES = [amwellErrors.SESSION_EXPIRED];

const isErrorOfType = (errorTypes: string[], action?: AnyAction) => {
  if (!action || !action.error || !(action.error instanceof AwsdkError)) {
    return false;
  }
  return errorTypes.includes(action.error.errorCode);
};

const amwellMiddleware: Middleware = ({ dispatch }) => next => async action => {
  const isExpired = isErrorOfType(EXPIRED_TYPES, action);
  const isLogout = isActionOfType(LOGOUT_TYPES, action);

  if (isExpired) {
    dispatch(awActions.setActivityStatus(ActivityStatus.EXPIRED));
  }

  if (isExpired || isLogout) {
    await dispatch(awActions.logout());
  }

  return next(action);
};

export default amwellMiddleware;
